import React from 'react';
import Modal, { ModalTitle } from '../../components/Modal';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import { useGetUser } from '../useAllUsers';
import UserProfileSettingsForm from './UserProfileSettingsForm';

const USER_FRAGMENT = gql(`
  fragment UserProfileSettingsModal_user on User {
    id
    ...useGetUser_user
  }
`);

interface UserProfileSettingsModalProps {
  close: () => void;
  user: DocumentType<typeof USER_FRAGMENT>;
}

const UserProfileSettingsModal = ({
  close,
  user,
}: UserProfileSettingsModalProps) => {
  const getUser = useGetUser();

  return (
    <Modal>
      <ModalTitle close={close}>Edit user profile</ModalTitle>
      <UserProfileSettingsForm
        user={getUser(user)}
        onComplete={() => close()}
      />
    </Modal>
  );
};

export default UserProfileSettingsModal;
